import { useEffect, useRef, useState } from "react";
import Buttons from "../../components/ui/button/Buttons";
import FormCreator from "../../components/Forms/FormCreator";
import { useNavigate, useParams } from "react-router-dom";
import { decryptAESID } from "../../utils/Encryption";
import { useLazyGetAllDropDownsForMemberDirectoryQuery, useLazyGetPDFQuery, useUploadPDFMutation } from "../../app/services/common/commonApi";
import { setDropDownField, setFieldParameter } from "./utils/setFieldParameter";
import { VerifiedCompetencyData } from "./data/AddVerifiedCompetency.data";
import { useLazyGetCompetencyDetailsByIdQuery, useUpdateVerifiedCompetencyMutation, useVerifiedCompetencyRejectOrApproveMutation } from "../../app/services/GMAP/verifiedCompetency";
import { APIUrl } from "../../utils/API/fetchBaseQuery";
import SwalAlert from "../../services/swalService/SwalService";

const VerifiedCompetencySubmissionForm = () =>
{
    const { editId } = useParams();
    const id = editId ? decryptAESID( editId, false ) : 0
    const navigate = useNavigate();
    const verifiedCompetencySubmissionRef = useRef();
    const [ formData ] = useState( VerifiedCompetencyData );
    const { success, error } = SwalAlert();
    const [ uploadData, setUploadData ] = useState( {
        fileName: "",
        uploadedFileName: ""
    } );
    const [ getAllDropDowns, { isLoading: getDropdownDataIsLoading, data: getDropdownData, isSuccess: getAllDropdownDataIsSuccess }, ] = useLazyGetAllDropDownsForMemberDirectoryQuery();
    const [ getCompetencyDetails, { isLoading: getDataLoading, data: memberData, isSuccess: isSuccess }, ] = useLazyGetCompetencyDetailsByIdQuery();
    const [ getPDF ] = useLazyGetPDFQuery();
    const [ verifiedCompetencyRejectOrApprove, { isSuccess: isAddMemberSuccess, isLoading: isAddMemberLoading, data: addMemberData }, ] = useVerifiedCompetencyRejectOrApproveMutation();
    const [ UpdateVerifiedCompetency, { isSuccess: isupdateVerifiedSuccess, isLoading: isUpdateVerifiedLoading, data: updateVerifiedData }, ] = useUpdateVerifiedCompetencyMutation();
    const [ UpdateVerifieCompetency, { isSuccess: isupdateVerifieSuccess, isLoading: isUpdateVerifieLoading, data: updateVerifieData }, ] = useUpdateVerifiedCompetencyMutation();
    const [ uploadPDF, { isSuccess: isUploadSuccess, isLoading: isUploadLoading, data: fileUploadData } ] = useUploadPDFMutation();

    useEffect( () =>
    {
        getAllDropDowns();
        if ( editId )
        {
            getCompetencyDetails( id )
        }
    }, [ editId ] );

    useEffect( () =>
    {
        if ( !isUploadLoading && isUploadSuccess && fileUploadData )
        {
            setUploadData( {
                fileName: fileUploadData?.fileName,
                uploadedFileName: fileUploadData?.uploadedFileName
            } );
        }
    }, [ isUploadLoading, isUploadSuccess, fileUploadData, ] );

    useEffect( () =>
    {
        if ( !getDropdownDataIsLoading && getAllDropdownDataIsSuccess && getDropdownData )
        {
            setDropDownField( getDropdownData )
        }
    }, [ getDropdownDataIsLoading, getDropdownData, getAllDropdownDataIsSuccess ] );

    useEffect( () =>
    {
        if ( !getDataLoading && isSuccess && memberData )
        {
            setFieldParameter( memberData )
        }
    }, [ getDataLoading, memberData, isSuccess ] );

    useEffect( () =>
    {
        if ( !isAddMemberLoading && isAddMemberSuccess && addMemberData )
        {
            if ( addMemberData?.isApproveOrReject )
            {
                success( "Application Approved Successfully" );
            }
            else
            {
                error( "Application has been rejected" );
            }
            setTimeout( () =>
            {
                navigate( '/verifiedCompetency' );
            }, 2000 );
        }
    }, [ isAddMemberLoading, isAddMemberSuccess, addMemberData, ] );

    useEffect( () =>
    {
        if ( !isUpdateVerifiedLoading && isupdateVerifiedSuccess && updateVerifiedData )
        {
            success( "Update Successfully" );
        }
    }, [ isUpdateVerifiedLoading, isupdateVerifiedSuccess, updateVerifiedData, ] );

    const handleSubmit = () =>
    {
        const formData = verifiedCompetencySubmissionRef.current.getFormData();
        if ( !formData )
        {
            return;
        }

        const updatedRequest = {
            GMPVerifiedCompetencyId: id || null,
            VerifiedCompetencyId: memberData?.verifiedCompetencyId || formData?.verifiedCompetency?.value,
            DateOfCertificate: formData?.dateofCertificate || memberData?.dateOfCertificate,
            CertificateFilename: uploadData?.uploadedFileName || memberData?.competencyFileName,
            Certificate: uploadData?.fileName || memberData?.competencyFile,
            InternalComments: formData?.internalComments || memberData?.internalComments,
            GmpNumber: memberData?.gmpNumber || formData?.gmpNumber || null,
        };
        UpdateVerifiedCompetency( updatedRequest );
    };

    const handleUpdate = () =>
    {
        const formData = verifiedCompetencySubmissionRef.current.getFormData();
        if ( !formData )
        {
            return;
        }

        const updatedRequest = {
            GMPVerifiedCompetencyId: id || null,
            VerifiedCompetencyId: memberData?.verifiedCompetencyId || formData?.verifiedCompetency?.value,
            DateOfCertificate: formData?.dateofCertificate || memberData?.dateOfCertificate,
            CertificateFilename: uploadData?.uploadedFileName || memberData?.competencyFileName,
            Certificate: uploadData?.fileName || memberData?.competencyFile,
            InternalComments: formData?.internalComments || memberData?.internalComments,
            GmpNumber: memberData?.gmpNumber || formData?.gmpNumber || null,
        };
        UpdateVerifieCompetency( updatedRequest );
    };

    const handleApprove = () =>
    {
        const formData = verifiedCompetencySubmissionRef.current.getFormData();
        if ( !formData )
        {
            return;
        }

        const updatedRequest = {
            VerifiedCompetencyId: id || null,
            InternalComments: formData?.internalComments || null,
            IsApproved: true,
        };
        verifiedCompetencyRejectOrApprove( updatedRequest );
        handleUpdate();
    };

    const handleReject = () =>
    {
        const formData = verifiedCompetencySubmissionRef.current.getFormData();
        if ( !formData )
        {
            return;
        }

        const updatedRequest = {
            VerifiedCompetencyId: id || null,
            InternalComments: formData?.internalComments || null,
            IsApproved: false,
        };
        verifiedCompetencyRejectOrApprove( updatedRequest );
    };

    const handleOnChangeFileUpload = async ( data ) =>
    {
        let formData = new FormData();
        formData.append( "file", data )
        formData.append( "storagePath", "VerfiedCompetency" );
        uploadPDF( formData );
    }

    const handleFormFieldChange = ( dataField, value ) =>
    {
        if ( dataField === "uploadFile" && value )
        {
            if ( value.type === "application/pdf" )
            {
                handleOnChangeFileUpload( value );
            }
        }
    };

    const handleDownload = async ( data, dataField ) =>
    {
        const request = {
            type: "",
            fileName: fileUploadData?.fileName || memberData?.competencyFile,
        }
        if ( dataField === "uploadFile" )
        {
            request.type = "VerfiedCompetency"
        }

        const response = await getPDF( request );
        const fileUrl = `${ APIUrl }/Common/getPDF?type=VerfiedCompetency&fileName=${ response?.data?.fileName }`;
        window.open( fileUrl, "_blank" );
    }

    const formActionHandler = {
        DOWNLOAD: handleDownload,
    }

    const handleBack = () =>
    {
        navigate( "/verifiedCompetency" );
    };

    return (
        <>
            <div>
                <div className="row">
                    <div className="col-lg-10">
                        { !getDropdownDataIsLoading &&
                            <div className="">
                                <FormCreator
                                    ref={ verifiedCompetencySubmissionRef }
                                    { ...formData }
                                    onActionChange={ formActionHandler }
                                    onFormFieldValueChange={ handleFormFieldChange }
                                />
                            </div>
                        }
                    </div>
                </div>
                { ![ 5, 6 ].includes( memberData?.statusId ) ?
                    <div className="mt-4 d-flex justify-content-between">
                        <Buttons
                            buttonText="Reject"
                            buttonTypeClassName="red-btn"
                            onClick={ handleReject }
                        />
                        <Buttons
                            buttonText="Approve"
                            buttonTypeClassName="success-btn"
                            onClick={ handleApprove }
                            isLoading={ isAddMemberLoading }
                            isDisable={ isAddMemberLoading }
                        />
                    </div>
                    :
                    <div className="mt-4 d-flex justify-content-between">
                    <div>
                      <Buttons
                        buttonText="Back"
                        buttonTypeClassName="btn btn-dark mt-3"
                        onClick={handleBack}
                      />
                    </div>
                  
                    <div className="d-flex gap-3">
                      {memberData?.statusId === 5 && (
                        <Buttons
                          buttonText="Reject"
                          buttonTypeClassName="red-btn mt-3"
                          onClick={handleReject}
                        />
                      )}
                      <Buttons
                        buttonText="Save"
                        buttonTypeClassName="success-btn mt-3"
                        onClick={handleSubmit}
                        isLoading={isUpdateVerifiedLoading}
                        isDisable={isUpdateVerifiedLoading}
                      />
                    </div>
                  </div>
                  
                }

            </div>
        </>
    );
};
export default VerifiedCompetencySubmissionForm;
